import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ProgressiveBar } from 'ustore-ui';

import { BUY_NOW_COUNTDOWN_SECONDS } from '../../../core/services/buy-now-redirect.service';
import { I18nPipe } from '../../pipes/i18n.pipe';

@Component({
  selector: 'umkt-buy-now-redirect-modal',
  standalone: true,
  imports: [CommonModule, MatIconModule, ProgressiveBar, I18nPipe],
  template: `
    @if (isVisible) {
      <div class="modal-overlay">
        <div class="modal-container" role="dialog" aria-modal="true">
          <div class="modal-content">
            <div class="modal-header">
              <h2>{{ 'components.buyNowRedirect.title' | i18n }}</h2>
              <button
                type="button"
                class="close-btn"
                [attr.aria-label]="'components.buyNowRedirect.closeButton' | i18n"
                (click)="onDismiss()">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="modal-body">
              <p>{{ 'components.buyNowRedirect.message' | i18n }}</p>

              <div class="countdown-section">
                <div class="time-display">
                  <span class="time-number">{{ remainingSeconds }}</span>
                  <span class="time-label">{{ 'components.buyNowRedirect.secondsRemaining' | i18n }}</span>
                </div>

                <ustore-progressive-bar
                  [currentValue]="totalSeconds - remainingSeconds"
                  [totalValue]="totalSeconds"
                  [barColor]="'#da291c'"
                  [backgroundColor]="'#cee7e8'"
                  [viewCurrentValue]="false"
                  [size]="'medium'"
                  [percentageDirection]="'center'">
                </ustore-progressive-bar>
              </div>

              <p class="fallback-hint">{{ 'components.buyNowRedirect.fallbackHint' | i18n }}</p>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="onDismiss()">
                {{ 'components.buyNowRedirect.closeButton' | i18n }}
              </button>
              <button
                type="button"
                class="btn btn-primary"
                (click)="onContinue()">
                {{ 'components.buyNowRedirect.openButton' | i18n }}
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  `,
  styleUrls: ['./buy-now-redirect-modal.component.scss']
})
export class BuyNowRedirectModalComponent {
  @Input() isVisible = false;
  @Input() remainingSeconds = BUY_NOW_COUNTDOWN_SECONDS;

  @Output() continueRedirect = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();

  readonly totalSeconds = BUY_NOW_COUNTDOWN_SECONDS;

  onContinue(): void {
    this.continueRedirect.emit();
  }

  onDismiss(): void {
    this.dismiss.emit();
  }
}
